export default {
      id: "huge-arrow-down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#huge-arrow-down",
      toString: function () {
        return this.url;
      }
    }